<script setup lang="ts">
import { Download, FileSpreadsheet, TriangleAlert, Upload } from "@lucide/vue";
import type { ImportedFile } from "./types";

defineProps<{
  file: ImportedFile;
  columnsCount?: number | null;
}>();
</script>

<template>
  <div class="tw:flex tw:flex-col tw:gap-4 tw:rounded-xl tw:border tw:border-zinc-200 tw:bg-white tw:p-4 tw:sm:flex-row tw:sm:items-center">
    <div class="tw:flex tw:min-w-0 tw:flex-1 tw:items-center tw:gap-4">
      <span class="tw:flex tw:size-11 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-lg tw:bg-green-50 tw:text-green-700">
        <FileSpreadsheet class="tw:size-5" />
      </span>
      <div class="tw:min-w-0 tw:flex-1">
        <div class="tw:truncate tw:font-medium">{{ file.name }}</div>
        <div class="tw:text-sm tw:text-zinc-500">
          {{ [
            file.dataRows !== null ? $t("{count} rows", { count: file.dataRows.toLocaleString() }) : null,
            columnsCount != null ? $t("{count} columns", { count: columnsCount }) : null,
          ].filter(Boolean).join(" · ") }}
        </div>
        <div v-if="file.trailingEmptyRows" class="tw:mt-1 tw:flex tw:items-center tw:gap-1.5 tw:text-sm tw:text-amber-700">
          <TriangleAlert class="tw:size-4 tw:shrink-0" />
          {{ $t("{count} empty rows at the end of the file will be ignored.", { count: file.trailingEmptyRows.toLocaleString() }) }}
        </div>
      </div>
    </div>
    <div class="tw:flex tw:items-center tw:gap-4 tw:text-sm tw:font-medium">
      <a :href="file.downloadUrl" class="tw:inline-flex tw:items-center tw:gap-1.5 tw:text-zinc-600 tw:hover:text-zinc-900">
        <Download class="tw:size-4" />
        {{ $t("Download") }}
      </a>
      <a v-if="file.replaceUrl" :href="file.replaceUrl" class="tw:inline-flex tw:items-center tw:gap-1.5">
        <Upload class="tw:size-4" />
        {{ $t("Replace file") }}
      </a>
    </div>
  </div>
</template>
